<div class="address-detail-comments-container ">
  <textarea maxlength="1000" class="commenttextarea" placeholder="Type here to reply." [(ngModel)]="commentText"></textarea>
  <div class="save-comment"><app-button (onClick)="saveComments()" text="ADD COMMENTS"></app-button></div>
  <app-comments [commentItems]="commentItems"></app-comments>
</div>


